import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { InProcessCollectionTransacitons } from "../../../../components/DirectDeposit/Transactions/InProcessCollection";

export interface IInProcessCollectionTransacitonsPage { }

export const InProcessCollectionTransacitonsPage: FC<IInProcessCollectionTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="In Process Collection"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<InProcessCollectionTransacitons />}
		/>
	);
};
